import { render } from "./DemographicInformation.vue?vue&type=template&id=b40886d6&ts=true"
import script from "./DemographicInformation.vue?vue&type=script&lang=ts"
export * from "./DemographicInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__